module.exports = __webpack_public_path__ + "assets/child.bf026ac6.svg";